import {
    BRAINTREEE_PAYMENT_DATA_UPDATE,
    PURCHASE_ORDER_PAYMENT_DATA_UPDATE,
    SELECT_PAYMENT_OPTION,
    NOTIFY_COMPLETE_CHECKOUT_ERROR,
    UPDATE_EBIZ_CHARGE_WEB_FORM_URL,
    EBIZ_CHARGE_WEB_FORM_URL_ERROR,
    BACK,
    UPDATING_EBIZ_CHARGE_WEB_FORM_URL_ASYNC, 
    SELECT_SHIPPING_OPTION
} from '../../GlobalStateContainer'

export const PaymentOptions = function (state = [], action) {
  return state;
}

export const SelectedPaymentOptionId = function(state = '', action) {
  switch (action.type) {
    case SELECT_PAYMENT_OPTION:
      return action.paymentMethodId || '';
    case NOTIFY_COMPLETE_CHECKOUT_ERROR:
      return '';
    default:
      return state;
  }
}

export const PaymentRecord = function (state = {}, action) {
  switch (action.type) {
    case BRAINTREEE_PAYMENT_DATA_UPDATE:
      return Object.assign({}, state,
        {
          BraintreePaymentNonce: action.payload && action.payload.nonce,
          BraintreePaymentPayload: action.payload
        });
    case PURCHASE_ORDER_PAYMENT_DATA_UPDATE:
      return Object.assign({}, state, { POValue: action.number });
    case NOTIFY_COMPLETE_CHECKOUT_ERROR:
      return Object.assign({}, state, { POValue: null, BraintreePaymentNonce: null, BraintreePaymentPayload: null, EbizChargePaymentStatus: null });
    default:
      return state;
  }
}

export const FetchingEBizChargePaymentWebFormUrl = function (state = false, action) {
  switch (action.type) {
    case UPDATING_EBIZ_CHARGE_WEB_FORM_URL_ASYNC:
      return true;
    case UPDATE_EBIZ_CHARGE_WEB_FORM_URL:
      return false;
    case EBIZ_CHARGE_WEB_FORM_URL_ERROR:
      return false;
    default:
      return state;
  }
}

/// <summary>
/// Expects EBizChargeWebFormDetails
/// url: string,
/// amount: decimal,
/// transactionId: string
/// </summary>
export const EBizChargePaymentWebFormUrl = function (state = {}, action) {
  switch (action.type) {
    case UPDATE_EBIZ_CHARGE_WEB_FORM_URL:
      return action.payload.Url;
    case BACK:
      return null;
    case EBIZ_CHARGE_WEB_FORM_URL_ERROR:
      return null;
    case SELECT_SHIPPING_OPTION:
      return null;
    case NOTIFY_COMPLETE_CHECKOUT_ERROR:
      return null;
    default:
      return state;
  }
}

export const EBizChargePaymentWebFormError = function (state = null, action) {
  switch (action.type) {
    case EBIZ_CHARGE_WEB_FORM_URL_ERROR:
      return true;
    case BACK:
      return false;
    default:
      return state;
  }
}
